import type { CommonSVGProps } from './helpers';

export const EmptyScheduledTaskCard = (props: CommonSVGProps) => (
  <svg
    fill="none"
    height={90}
    width={330}
    {...props}
  >
    <rect
      fill="#EFEFEF"
      fillOpacity={1}
      height={60}
      rx={8}
      width={148}
      x={91}
      y={30}
    />
    <rect
      fill="#DCDCDC"
      fillOpacity={1}
      height={5}
      rx={2.5}
      width={136}
      x={97}
      y={39}
    />
    <rect
      fill="#DCDCDC"
      fillOpacity={1}
      height={5}
      rx={2.5}
      width={66}
      x={97}
      y={48}
    />
    <rect
      fill="#ECDFF5"
      fillOpacity={1}
      height={16}
      rx={8}
      width={47}
      x={97}
      y={60}
    />
    <g clipPath="url(#a)">
      <path
        d="M102.336 68v-1a.998.998 0 0 1 1-1h4.333m0 0-1-1m1 1-1 1m1 1v1a.998.998 0 0 1-1 1h-4.333m0 0 1 1m-1-1 1-1"
        stroke="#5B366D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={1}
        strokeWidth={0.75}
      />
    </g>
    <path
      d="m278.5 18 11-11m-11 11 3.501 7a.542.542 0 0 0 .5.32.552.552 0 0 0 .5-.32L289.5 7m-11 11-6.999-3.5a.55.55 0 0 1 0-1L289.5 7"
      stroke="#E086A3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={1}
      strokeWidth={3}
    />
    <path
      d="M222 47.971c1.049-5.395 1.742-11.483 5.71-15.656 5.484-5.768 15.574-6.038 22.871-4.758 5.87 1.029 27.893 9.397 14.152 16.853-7.045 3.823-17.849-3.496-12.218-11.174 4.699-6.409 12.216-8.012 18.665-11.236"
      stroke="#E086A3"
      strokeLinecap="round"
      strokeOpacity={1}
      strokeWidth={3}
    />
    <defs>
      <clipPath id="a">
        <path
          d="M0 0h8v8H0z"
          fill="#fff"
          fillOpacity={1}
          transform="translate(101 64)"
        />
      </clipPath>
    </defs>
  </svg>
);
